import { graphql } from ':src/graphql';

type UsersByOrganizationIdQueryFilterEnum = ReturnType<
  typeof graphql.scalar<'UsersByOrganizationIdQueryFilter'>
>;
export const UsersByOrganizationIdQueryFilter = {
  AwaitingMatch: 'AWAITING_MATCH',
  Inactive: 'INACTIVE',
  Matched: 'MATCHED',
  NotInProgram: 'NOT_IN_PROGRAM',
  Pending: 'PENDING',
  Removed: 'REMOVED',
} as const satisfies Record<string, UsersByOrganizationIdQueryFilterEnum>;
export type UsersByOrganizationIdQueryFilter = UsersByOrganizationIdQueryFilterEnum;

type OrganizationAdminPermissionNameEnum = ReturnType<
  typeof graphql.scalar<'OrganizationAdminPermissionName'>
>;
export const OrganizationAdminPermissionName = {
  EditBilling: 'EDIT_BILLING',
  IntroCalls: 'INTRO_CALLS',
  ManageNotifications: 'MANAGE_NOTIFICATIONS',
  ManageOrganization: 'MANAGE_ORGANIZATION',
  MatchSuperviseeAndSupervisor: 'MATCH_SUPERVISEE_AND_SUPERVISOR',
  MatchSuperviseeAndSupervisorInProgram: 'MATCH_SUPERVISEE_AND_SUPERVISOR_IN_PROGRAM',
  ProgramCreate: 'PROGRAM_CREATE',
  ProgramDelete: 'PROGRAM_DELETE',
  ProgramEdit: 'PROGRAM_EDIT',
  ProgramView: 'PROGRAM_VIEW',
  ProgramViewAll: 'PROGRAM_VIEW_ALL',
  SelectPrograms: 'SELECT_PROGRAMS',
  SessionsViewAll: 'SESSIONS_VIEW_ALL',
  SuperviseesAdd: 'SUPERVISEES_ADD',
  SuperviseesDelete: 'SUPERVISEES_DELETE',
  SuperviseesEdit: 'SUPERVISEES_EDIT',
  SuperviseesViewAll: 'SUPERVISEES_VIEW_ALL',
  SupervisorsViewAll: 'SUPERVISORS_VIEW_ALL',
  UpdateAdmin: 'UPDATE_ADMIN',
  UpdateBillingManager: 'UPDATE_BILLING_MANAGER',
  UpdateClinicalDirector: 'UPDATE_CLINICAL_DIRECTOR',
  UpdateOrganization: 'UPDATE_ORGANIZATION',
  UpdateProgramDirector: 'UPDATE_PROGRAM_DIRECTOR',
  ViewBilling: 'VIEW_BILLING',
  ViewEntireTeam: 'VIEW_ENTIRE_TEAM',
  ViewTeam: 'VIEW_TEAM',
} as const satisfies Record<string, OrganizationAdminPermissionNameEnum>;
export type OrganizationAdminPermissionName = OrganizationAdminPermissionNameEnum;

type SortEnum = ReturnType<typeof graphql.scalar<'Sort'>>;
export const Sort = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const satisfies Record<string, SortEnum>;
export type Sort = SortEnum;

type CancelledWithNoticeFilterEnum = ReturnType<typeof graphql.scalar<'CancelledWithNoticeFilter'>>;
export const CancelledWithNoticeFilter = {
  IncludeAllAttendeesCancelled: 'INCLUDE_ALL_ATTENDEES_CANCELLED',
  IncludeAttendeeCancelled: 'INCLUDE_ATTENDEE_CANCELLED',
  ExcludeAttendeeCancelled: 'EXCLUDE_ATTENDEE_CANCELLED',
  ExcludeAllAttendeesCancelled: 'EXCLUDE_ALL_ATTENDEES_CANCELLED',
} as const satisfies Record<string, CancelledWithNoticeFilterEnum>;
export type CancelledWithNoticeFilter = CancelledWithNoticeFilterEnum;

type SupervisorTypeFilterEnum = ReturnType<typeof graphql.scalar<'SupervisorTypeFilter'>>;
export const SupervisorTypeFilter = {
  External: 'EXTERNAL',
  Internal: 'INTERNAL',
} as const satisfies Record<string, SupervisorTypeFilterEnum>;
export type SupervisorTypeFilter = SupervisorTypeFilterEnum;
